export type TLegalType = 0 | 1 | 2 | 999 | 220 | 221;

export interface ISelectData {
  id: string | number;
  label: string;
  checked: boolean;
}

export interface IdeaContent {
  /**
   * 手段
   */
  means: string;
  /**
   * 功效
   */
  efficacy: string;
}

/**
 * 翻译选项
 */
export enum TRANSLATE_LANGUAGES {
  /**
   * 不翻译
   */
  NONE = 'NONE',
  /**
   * 翻译成英文
   */
  ENGLISH = 'EN',
  /**
   * 翻译成中文
   */
  CHINESE = 'CN',
  /**
   * 翻译成日文
   */
  JAPANESE = 'JP'
}

export interface IOrgInfo {
  display_name: string;
  id: string;
  logo: string;
}

export interface IBaseSolution {
  pn?: string;
  similarity?: string;
  title?: string;
  means?: string;
  efficacy?: string;
  full_means?: string;
  full_efficacy?: string;
  org_info?: IOrgInfo[];
  apd?: string;
  pdf_image?: ImageRecord[];
  pdf_image_count?: number;
  legal_status?: number;
  patent_id: string;

  order?: number;

  /**
   * 是否已经加入报告列表
   */
  addedReport?: boolean;

  /**
   * 是否通过PN号搜索加入结果列表
   */
  manualAddIntoResult?: boolean;

}

export interface ICheckResultResponse {
  items: IBaseSolution[];
  lang: TRANSLATE_LANGUAGES;
}

export interface IOneProfileRequest {
  patent_id?: string;
  means?: string;
  efficacy?: string;
}

export interface ISuggestList {
  PATENT_ID: string;
  PN: string;
}

export interface IPatent {
  pn: string;
  title: string;
  relevantPart: string;
  apno: string;
}

export interface IComparingData {
  title: string;
  description: string;
  images: string[];
}

export interface IFeatureData {
  curr: string;
  patent: string;
}

export interface IDocCompareData {
  info: {
    title: string;
    pn: string;
    org: string;
    similarity: string;
    orgLogo?: string;
    patent_id: string
  };
  list: IComparingData[];
  featureList: IFeatureData[];
}

export interface IResultData {
  title: string;
  desc: string;
}

export interface IReportPatent {
  patent_id: string;
  pn: string;
  similarity: string;
  title: string;
  apd: string;
  pbd: string;
  org: string;
  relate: string;
  figures: string[];
  means: string;
  efficacy: string;
  tech_pro: string;
  tech_mean: string;
  tech_efficacy: string;
  org_logo?: string;
}

export interface IReportData {
  analysis_result: string;
  analysis_text: string[];
  pair_patents: IReportPatent[];

  has_novelty: boolean;
}

export interface IAdc {
  code: number;
  description: string;
  level: number;
  href?: string
}

export interface IDetailSummaryResponse {
  SOLUTION_TYPE: string;
  ABST: string;
  ORG_INFO: IOrgInfo;
  SOLUTION_ID: string;
  PBD: string;
  ADC: IAdc[];
  EFFICACY?: string;
  MEANS?: string;
}

export interface IDetailSummary {
  summary: string;
  technicalMeans: string;
  technicalEffect: string;
  applicant: string;
  applicantImage: string;
  applicationDate: string;
  applicationDomains: string[];
}

export interface IDetailSummaryParams {
  lang: TRANSLATE_LANGUAGES;
  trans_lang: TRANSLATE_LANGUAGES;
  patent_id: string;
  means: string;
  efficacy: string;
}

export interface IPatentImageParams {
  limit?: number;
  page?: number;
  with_patent_image: boolean;
  patent_image_count?: number;
}

export interface ImageRecord {
  image_id: string;
  storage_path: string;
  fulltext_image240_url: string;
  image_from: string;
  official_size?: string;
  image_type?: string;
}
export interface IDetailImage {
  page: number;
  limit: number;
  total: number;
  records: ImageRecord[];
  has_previous: boolean;
  has_next: boolean;
  patent_image_count: number;
}

export interface IDisclosureAnalysisData {
  dimensions: Record<string, unknown>[];
  source: Record<string, unknown>[];
  total: Record<string, Array<number>>;
  extra: Record<string, unknown>;
}

export interface IExportDocParams {
  source_means: string;

  source_efficacy: string;
  /**
   *相似专利集合
   */
  pair_patents: IBaseSolution[];
}

export interface IRequestPatentData {
  tab?: string;
  lang?: TRANSLATE_LANGUAGES;
  trans_lang?: TRANSLATE_LANGUAGES;
  patent_id: string;
  means: string;
  efficacy: string;
}

export interface IReportDetailParams {
  pair_patents: {
    patent_id: string
    similarity?: string
  }[]
  lang: TRANSLATE_LANGUAGES;
  source_means: string;
  source_efficacy: string;
}

export interface IPairPatent {
  patent_id: string; // 专利ID
  pn: string; // 专利号
  title: string; // 专利标题
  relate: string; // 相关信息
  means: string; // 技术手段
  efficacy: string; // 技术效果
}

export interface IExportReportData {
  lang: TRANSLATE_LANGUAGES;
  pair_patents: IPairPatent[]; // 专利对列表
  source_means: string; // 技术来源
  source_efficacy: string; // 技术效果来源
  result: string; // 结果
  company: string; // 公司
  company_cloud: string; // 公司云
  company_phrase: string[]; // 公司短语
  analysis_cloud_img: string; // 词云图像数据
  analysis_efficacy_img: string; // 技术效果图像数据
  country_img: string;
  is_ppt?: boolean;
  has_novelty?: boolean;
}

export interface ISrpRequest {
  means: string;
  efficacy: string;
  country?: string[];
  legal?: TLegalType[];
}

export interface IResponseContentStorage {
  means: string,
  efficacy: string,
  means_overrun: boolean,
  efficacy_overrun: boolean
}

export interface IPatentGPTSummary {
  improvement_direction: string[],
  innovation_point: string[]
}
